// Single place that reads the environment. Nothing else in the app touches
// process.env, so swapping a value is a .env edit and a rebuild.
//
// Every field has a usable fallback: the site must render complete and
// presentable even with an empty .env, because the real registered details are
// filled in later. See .env.example.

const env = process.env;

function val(key, fallback = "") {
  const v = env[key];
  return v === undefined || v === null || v === "" ? fallback : v;
}

export const company = {
  brand: val("REACT_APP_COMPANY_BRAND", "Astrid Ecosystems"),
  legalName: val("REACT_APP_COMPANY_LEGAL_NAME", "Astrid Ecosystems LLC"),
  address: val("REACT_APP_COMPANY_ADDRESS"),
  email: val("REACT_APP_COMPANY_EMAIL"),
  // Optional by design. Empty means the phone row is not rendered at all,
  // which reads better than an empty field.
  phone: val("REACT_APP_COMPANY_PHONE"),
  // Used in prose and in the footer: "Registered in the State of New Mexico".
  // Also the governing-law clause in the Terms, so it has to match reality.
  jurisdiction: val("REACT_APP_COMPANY_JURISDICTION", "the State of New Mexico"),
  // Short form for the hero eyebrow: "ASTRID ECOSYSTEMS LLC / NEW MEXICO, UNITED STATES".
  location: val("REACT_APP_COMPANY_LOCATION", "New Mexico, United States"),
  siteUrl: val("REACT_APP_SITE_URL").replace(/\/$/, ""),
};

export const contact = {
  // Empty endpoint means the form falls back to a mailto: submission rather
  // than silently pretending to send.
  endpoint: val("REACT_APP_CONTACT_ENDPOINT"),
};

export const foundedYear = 2024;
